import React from 'react'
import CustomTable from '../../../../elements/Table/CustomTable'
import { Button } from 'antd'

function RolesList (props) {
  const { list, fetch, fetching, onShow } = props

  const columns = [
    {
      Header: 'Name',
      accessor: 'name',
      Cell: ({ value, original }) => <a onClick={() => onShow(original, 'edit')}>{value}</a>,
    },
    { Header: 'Report To', accessor: 'reportto' },
    { Header: 'Certification', accessor: 'certification' },
    { Header: 'Description', accessor: 'description' },
    { Header: 'Task', accessor: 'task' },
  ]

  return (
    <CustomTable
      data={list}
      isFilterable={true}
      fetching={fetching}
      fetch={fetch}
      CreateButton={() => (
        <Button type={'primary'} size="small" icon={'plus'} onClick={onShow}>
          Add New Role
        </Button>
      )}
      columns={columns}
      defaultSorted={[
        {
          id: 'day',
          desc: false,
        },
      ]}
    />
  )
}

RolesList.propTypes = {}
RolesList.defaultProps = {}

export default RolesList
